/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import withQuillLayout from 'src/_common/hoc/QuillLayout';
import React, { useRef } from 'react';
import dynamic from 'next/dynamic';
import {
  CircularProgress,
  Grid,
  Container,
  Hidden,
  SvgIcon,
  Button,
  Theme,
  useTheme,
  styled,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import HideInMobile from 'src/_common/quillElements/fragment/HideinMobile';
import ShowInMobile from 'src/_common/quillElements/fragment/ShowInMobile';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import TryFeature from 'src/mics/components/try/TryFeature';
import Herosection from 'src/mics/components/try/HeroSection';
// import TestimonialSection from 'src/mics/components/try/TestimonialSection';
import TryHomeGetPremium from 'src/mics/components/try/TryHomeGetPremium';
import css from 'assets/scss/try.module.scss';
import LoadWithAnimation from 'src/_common/components/LoadWithAnimation';
import Paraphraser from 'src/paraphraser/index';
import Link from '@Common/components/Link';
import Head from 'next/head';
import { DownArrowIcon } from 'src/_common/quillElements/icon';
// import HerosectionSeo from 'src/mics/components/try/HeroSectionSeo';
import StyledPremiumButton from '@Common/quillElements/button/PremiumButton';
import { NpsScoreModal } from '@Common/components/NpsScoreModal';
import ABTest from '@Common/hoc/ABTest';

// const SignUpDialog = dynamic(() => import('src/_common/components/SignUpDialog'), {
//   ssr: false,
// });

const NewSignUpDialog = dynamic(() => import('src/_common/components/NewSignUpDialog'), {
  ssr: false,
});

const ParaphraserDrawerControlBar = dynamic(
  () => import('src/paraphraser/components/ParaphraserDrawerControlBar'),
  {
    ssr: false,
  }
);

interface PropsObject {
  isMobile: boolean;
}

const useStyles = makeStyles<Theme, PropsObject>((theme) => ({
  homeScrollBtn: {
    backgroundColor: theme.palette.grey[600],
  },

  homepagePremiumBg: {
    paddingTop: '35px',
  },

  downIcon: {
    // TODO: test md changes
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bottomText: {
    fontSize: '24px',
    fontWeight: 'normal',
    textAlign: 'center',
    padding: '0px 0px',
    maxWidth: '510px',
    margin: '1.5em auto 0px',
  },
  // homePageBootom: {
  // },
  halfgreencercle: {},

  // orangeDoubleCercle: {
  // },

  containerBox: {},

  containerBoxEven: {},

  testimonialHolderPremium: {},

  heroSectionBackground: {
    backgroundColor: (props) => (props.isMobile ? '#FBF7F0' : '#fff'),
  },
  mobileBackground: {
    paddingTop: '25px',
    paddingBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      // backgroundImage: "url('./images/landinPage/ellipse.png')",
      backgroundRepeat: 'no-repeat !important',
      backgroundPosition: '0% 140px',
      [theme.breakpoints.down(500)]: {
        backgroundPosition: '0% 160px',
      },
      [theme.breakpoints.down(400)]: {
        backgroundPosition: '0% 200px',
      },
      [theme.breakpoints.down(300)]: {
        backgroundPosition: '0% 240px',
      },
    },
    [theme.breakpoints.down(600)]: {
      paddingBottom: '45px',
    },
  },
  bottomSignupBtn: {
    textAlign: 'center',
    margin: '84px 0px 80px',
    [theme.breakpoints.down(600)]: {
      margin: '54px 0px 50px',
    },
  },
  containerBoxMobile: {
    textAlign: 'center',
    paddingTop: '35px',
    [theme.breakpoints.down(600)]: {
      backgroundColor: theme.palette.grey[600],
      paddingTop: '20px',
    },
  },
}));

const StyledLoader = styled(Grid)`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 13px;
  height: calc(50vh + 105px);
  background-color: #fff;
  @media only screen and (max-width: 767px) {
    height: calc(50vh + 140px);
  }
`;

const StyledLoadingContainer = styled(Grid)`
  && {
    border-radius: 13px;
    box-shadow: rgba(31, 31, 31, 0.15) -1px 4px 12px 0px;
    position: relative;
    margin: 0;
    padding: 0;
    background-color: rgba(235, 244, 238, 0.69);
  }
`;

export const loadingBar = () => (
  <div>
    <ShowInMobile>
      <div
        style={{
          height: 42,
          backgroundColor: 'rgba(235, 244, 238, 0.69)',
        }}
      />
      <div style={{ borderTop: '1px solid #e1e1e1' }} />
      <div
        style={{
          height: 25,
          backgroundColor: 'rgba(235, 244, 238, 0.69)',
        }}
      />
      <Grid
        item
        xs={12}
        style={{
          margin: 0,
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          height: '1000px',
          backgroundColor: '#FFF',
        }}
      >
        <CircularProgress color="secondary" />
      </Grid>
    </ShowInMobile>
    <HideInMobile>
      <Container maxWidth={false} className="root-container home-container-gray">
        <StyledLoadingContainer container justifyContent="center" alignItems="flex-start">
          <StyledLoader item xs={12}>
            <CircularProgress />
          </StyledLoader>
        </StyledLoadingContainer>
      </Container>
    </HideInMobile>
  </div>
);

/* const Paraphraser = dynamic(() => import('src/paraphraser/index.jsx'), {
  loading: loadingBar,
  ssr: false,
}); */

// this schema is for SEO
const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'QuillBot',
  description:
    'QuillBot’s paraphrasing, summarizing and grammar checker tools are trusted by millions worldwide to rewrite sentences, paragraphs, or articles using state-of-the-art AI.',
  url: 'https://quillbot.com/',
  logo: 'https://quillbot.com/images/QuillBotLogo.svg',
  foundingDate: '2017',
  founders: [
    {
      '@type': 'Person',
      name: 'Rohan Gupta',
    },
    {
      '@type': 'Person',
      name: 'Anil Jason',
    },
    {
      '@type': 'Person',
      name: 'David Silin',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '200 E. Randolph St. (Aon Center) Suite 5215',
    addressLocality: 'Chicago',
    addressRegion: 'IL',
    postalCode: '60601',
    addressCountry: 'USA',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'support@quillbot.com',
  },
  sameAs: [
    'https://www.facebook.com/thequillbot/',
    'https://twitter.com/thequillbot',
    'https://www.linkedin.com/company/quillbot/',
    'https://www.instagram.com/thequillbot/',
    'https://in.pinterest.com/TheQuillBot/',
  ],
};

function Home() {
  const isMobileCheck = useSelector((rootState: RootState) => rootState?.common.platform?.isMobile);
  const isDesktop = useSelector((rootState: RootState) => rootState?.common.platform?.isDesktop);
  const props = { isMobile: isMobileCheck };
  const classes = useStyles(props);
  // const [isLoaded, setIsLoaded] = useState(false);
  const arrowIconRef = useRef<HTMLDivElement>(null);
  const isPremium = useSelector((rootState: RootState) => rootState?.user?.premium);
  const availedRefund = useSelector((rootState: RootState) => rootState?.user?.availedRefund);
  // const isSyncWithDB = useSelector((rootState: RootState) => rootState?.user?.syncedWithDb);
  const isAuthenticated = useSelector((rootState: RootState) => rootState?.user?.isAuthenticated);
  const isExtension = useSelector(
    (rootState: RootState) => rootState?.common.platform?.isExtension
  );
  const native = useSelector((rootState: RootState) => rootState?.common.platform?.native);
  const isKeyboardOpen = useSelector((rootState: RootState) => rootState?.common.isKeyboardOpen);
  const inputText = useSelector((rootState: RootState) => rootState.pphr.inputText);
  const quillingStarted = useSelector((rootState: RootState) => rootState.pphr.startedQuilling);
  const theme = useTheme();

  const npsProps = { inputText, quillingStarted };
  // const dispatch = useDispatch();
  // const paraphraseSummaryData = (data: ParaphraseSummaryData) => {
  //   const inputBoxElem = document.getElementById('inputText');
  //   if (inputBoxElem) {
  //     // resetting the file name on paraphrase summary
  //     // ParaModel.uploadedFileInfo = { fileName: '', fileType: '' };
  //     dispatch(setUploadFileInfo({ fileName: '', fileType: '' }));

  //     // ParaModel.paraphrase(data.summary);
  //     dispatch(paraphrase(data.summary));
  //   } else {
  //     // handling the case when user direcly lands on summarizer and then navigtes to paraphraser => wait for input box to render
  //     setTimeout(() => paraphraseSummaryData(data), 500);
  //   }
  // };
  // const onLoad = () => {
  //   // if (isLoaded) return;
  //   // QuillEventEmitter.getInstance().on('PPHR_SMZR_EVENT', paraphraseSummaryData);
  //   // ParaModel.registerListeners();
  //   // setIsLoaded(true);
  // };

  // useEffect(() => {
  //   // appLoaded(onLoad);
  //   onLoad();

  //   return () => QuillEventEmitter.getInstance().off('PPHR_SMZR_EVENT');
  // }, []);

  const handleTryPremiumSectionArrowIcon = () => {
    window.scrollTo({
      top: arrowIconRef.current != null ? arrowIconRef.current?.offsetTop : 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          key="company-schema"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
      {/* {isLoaded ? <Paraphraser /> : loadingBar()} */}
      <Paraphraser />
      {isAuthenticated && isDesktop ? <NpsScoreModal {...npsProps} /> : null}
      {!isKeyboardOpen && !isPremium && !isExtension && !native && (
        <>
          {isAuthenticated ? (
            <Grid
              container
              justifyContent="center"
              className={classes.homeScrollBtn}
              // style={{ background: '#F8F8F8' }}
              ref={arrowIconRef}
            >
              {/* <Hidden only={['sm', 'xs']}> */}
              <Button
                // size="medium"
                disableRipple
                className={classes.downIcon}
                onClick={handleTryPremiumSectionArrowIcon}
              >
                <DownArrowIcon />
              </Button>
              {/* </Hidden> */}
              {/* <TryHomeGetPremium referrer="convertUser" /> */}
              <TryHomeGetPremium />
            </Grid>
          ) : (
            <>
              <Grid
                container
                justifyContent="center"
                className={`${classes.containerBox}  `}
                //  style={{ background: '#fff' }}
                ref={arrowIconRef}
              >
                <Hidden only={['sm', 'xs']}>
                  <Button
                    // size="medium"
                    onClick={handleTryPremiumSectionArrowIcon}
                  >
                    <SvgIcon viewBox="0 0 39 14" style={{ width: '39px', color: '#fff' }}>
                      <path
                        d="M2 2L19.1613 12L37 2"
                        stroke="#CFCFCF"
                        strokeWidth="3"
                        strokeLinecap="round"
                        fill="transparent"
                      />
                    </SvgIcon>
                  </Button>
                </Hidden>
              </Grid>
              {/* <SignUpDialog /> */}
              <NewSignUpDialog />
              <Grid
                container
                justifyContent="center"
                // className={`${classes.containerBox} ${classes.containerBoxEven} ${classes.mobileBackground}`}
                className={`${classes.containerBox} ${classes.mobileBackground}`}
              >
                <Grid
                  item
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <div className={`${css.heroSection}`}>
                    <h1 className={`${css.sectionTitle}`} style={{ fontSize: '23px' }}>
                      QuillBot&#39;s paraphrasing tool helps millions of people rewrite and enhance
                      any sentence, paragraph, or article using state-of-the-art AI.
                    </h1>
                  </div>
                  <p style={{ maxWidth: '910px', padding: '0px 15px' }}>
                    Your words matter, and our paraphrasing tool is designed to ensure you use the
                    right ones. With 2 free modes and 5 premium modes to choose from, QuillBot’s
                    paraphraser can rephrase any text in a variety of different ways, guaranteeing
                    you find the perfect language, tone, and style for any occasion. Just enter your
                    text into the input box, and our AI will work with you to build the best
                    paraphrase from the original piece of writing.{' '}
                  </p>
                </Grid>
              </Grid>

              <HideInMobile>
                <TryFeature />
              </HideInMobile>
              <Grid
                container
                // style={{ background: '#fff' }} ${classes.heroSectionBackground}
                // className={`${classes.containerBox} ${css.lightBlueBg}`}
                className={classes.containerBoxMobile}
              >
                {/* ========= hero section start =========== */}
                <Grid container justifyContent="center">
                  <Grid item>
                    <div className={`${css.heroSection}`}>
                      <h2 className={`${css.sectionTitle} ${css.sectionTitle2}`}>
                        QuillBot&#39;s Paraphraser helps you write better, faster, and clearer
                      </h2>
                      <HideInMobile>
                        <p>
                          QuillBot is trusted by students, writers, and professionals
                          <br />
                          who simply want to write better.
                        </p>
                      </HideInMobile>
                      <ShowInMobile>
                        <p
                          style={{
                            fontSize: '15px',
                            alignItems: 'center',

                            textAlign: 'center',
                            lineHeight: '155%',
                            fontWeight: 'normal',
                          }}
                        >
                          QuillBot is trusted by students, professional writers, and business people
                          who simply want to write better.
                        </p>
                      </ShowInMobile>
                    </div>
                  </Grid>
                </Grid>

                <Herosection />
                {/* ========= hero section end =========== */}
              </Grid>
            </>
          )}

          {/* <Grid
            container
            className={`${css.homepagePremiumBg} `}
            style={{
              backgroundColor: '#fff',
              paddingTop: '35px',
            }}>
            <div className={`${css.testimonialHolderPremium} `}>
              <TestimonialSection />
            </div>
          </Grid> */}
          {isAuthenticated ? (
            <div
              className={`${css.orangeDoubleCercle} ${css.container} ${classes.containerBoxEven}`}
              style={{
                backgroundImage: "url('./images/landinPage/orangeDoubleCercleNew.svg')",
                marginTop: '38px',
              }}
            >
              <Grid container justifyContent="center">
                <Grid item xs={12} lg={12} md={12} sm={12} style={{ textAlign: 'center' }}>
                  <h3
                    style={{
                      fontSize: '24px',
                      textAlign: 'center',
                      fontWeight: 'normal',
                      padding: '0px 0px',
                      maxWidth: '510px',
                      margin: '1em auto 2em',
                    }}
                  >
                    Whether you’re writing emails, essays, or social media posts, QuillBot has your
                    back.
                  </h3>
                </Grid>
                <LoadWithAnimation animationType="grow">
                  <Grid
                    item
                    xs={12}
                    // lg={12}
                    // md={12}
                    // sm={12}
                    style={{ textAlign: 'center', marginBottom: '50px' }}
                  >
                    {/* <a
                      rel="noopener noreferrer"
                      href="/premium?referrer=homePageCovertUsers"
                      target="_blank"
                      onClick={() => Track.getInstance().premiumLinkClicked('bottomSection')}
                      className={`${css.yellowBtn} ${css.dimondIconBtn}`}
                      style={{ fontWeight: 600 }}>
                      <img
                        src="./images/landinPage/dimondIconBtn.svg"
                        className={` ${css.dimondIcon} `}
                        alt=""
                      />
                      Get Premium
                    </a> */}
                    <StyledPremiumButton
                      style={{
                        fontWeight: 600,
                        borderRadius: '50px',
                        textAlign: 'center',
                        fontSize: '20px',
                        minHeight: '50px',
                        padding: '0px 55px',
                      }}
                      referrer="homePageCovertUsers"
                    />
                    {!availedRefund && (
                      <p style={{ fontSize: '16px', fontStyle: 'italic', margin: '12px auto' }}>
                        3 Day Money-Back Guarantee
                      </p>
                    )}
                  </Grid>
                </LoadWithAnimation>
              </Grid>
            </div>
          ) : (
            <Grid
              container
              justifyContent="center"
              // className={classes.homePageBootom}
              // style={{ background: '#ffffff' }}
            >
              <Grid item lg={12} xl={12} md={12} sm={12} xs={12} style={{ textAlign: 'center' }}>
                <div
                  className={`${css.halfgreencercle} ${css.container} ${classes.halfgreencercle} `}
                  style={{
                    backgroundImage: `url('./images/theme/${theme.palette.mode}/paraphraser/halfGreenCircle.svg')`,
                    marginTop: '38px',
                    paddingBottom: '20px',
                  }}
                >
                  <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12} md={12} sm={12} style={{ textAlign: 'center' }}>
                      <div style={{ maxWidth: '915px', margin: 'auto' }}>
                        <h2
                          className={classes.bottomText}
                          style={{ margin: '1em auto 1em', maxWidth: '601px' }}
                        >
                          Whether you’re writing emails, essays, or social media posts,
                          QuillBot&#39;s paraphrasing tool has your back.
                        </h2>
                        <p style={{ padding: '0px 3px' }}>
                          No matter who you are or what you do, QuillBot has writing and research
                          tools to support you in making your work come alive. Authors, students,
                          researchers, journalists, attorneys, and everyone in between have employed
                          the paraphraser to reword writing for school essays, professional
                          correspondence, creative storytelling, and personal projects. Writing with
                          confidence will change the way you interact with the world, and QuillBot
                          is ready to help you elevate your skills. If you’re looking to paraphrase
                          online, there’s only one place to go, and you’re already here.{' '}
                        </p>
                        <h3 className={classes.bottomText}>Grammar Checker</h3>
                        <p style={{ marginTop: '5px', padding: '0px 3px' }}>
                          When your draft is complete, and you’ve ironed out all of the bumps in
                          your content, put the final polish on your written work quickly and easily
                          with our new{' '}
                          <Link href="/grammar-check">
                            <a>Grammar Checker</a>
                          </Link>
                          . With one click, QuillBot will scan your writing and alert you to any
                          errors in grammar, spelling, punctuation, word misuse, and more so that
                          you can easily see what’s amiss and fix it fast.
                        </p>
                        <h3 className={classes.bottomText}>Summarizing Tool</h3>
                        <p style={{ marginTop: '5px', padding: '0px 3px' }}>
                          When it comes to staying on top of your reading list, try our instant text
                          summary tool--a.k.a. the{' '}
                          <Link href="/summarize">
                            <a>Summarizer</a>
                          </Link>
                          . Let QuillBot’s AI sift through research papers, news articles, or
                          long-winded emails to identify the main points and give you a high-level
                          overview of the material.{' '}
                        </p>
                      </div>
                    </Grid>
                    <LoadWithAnimation animationType="grow">
                      <Grid item className={classes.bottomSignupBtn}>
                        <Link
                          href={{
                            pathname: '/signup',
                            query: { referrer: 'homePageEducateUser' },
                          }}
                        >
                          <Button
                            color="primary"
                            variant="contained"
                            style={{
                              fontWeight: 400,
                              borderRadius: '50px',
                              textAlign: 'center',
                              fontSize: '20px',
                              minWidth: '275px',
                              lineHeight: '48px',
                              minHeight: '50px',
                              padding: '0px 27.5px',
                            }}
                          >
                            Sign up for free today
                          </Button>
                        </Link>
                        {/*
                        <p style={{ fontSize: '16px', fontStyle: 'italic', margin: '12px auto' }}>
                          No Credit Card Required
                        </p> */}
                      </Grid>
                    </LoadWithAnimation>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
}

export default withQuillLayout({
  children: Home,
  drawerProp: ParaphraserDrawerControlBar,
});
